import React, { PureComponent, Fragment } from 'react';

import { numberFormat } from '~/core/scripts/utils';
import withSlide from '~/kits/general/scripts/components/withSlide';
import ParliamentVis from '~/kits/general/scripts/components/ParliamentVis';
import data from '~/assets/data/map.csv';

const findEU = d => d.country === 'EU';

const allSeats = +data.find(findEU).all_2019;
const scepticsSeats = +data.find(findEU).spec_2019;
const rightWingSeats = +data.find(findEU).right_2019;
const otherSeats = allSeats - scepticsSeats - rightWingSeats;

const parliamentData = {
  other: { colour: '#ddd', seats: otherSeats, relSeats: (otherSeats / allSeats) * 100 },
  sceptics: { colour: '#547ac0', seats: scepticsSeats, relSeats: (scepticsSeats / allSeats) * 100 },
  rightwing: { colour: '#222', seats: rightWingSeats, relSeats: (rightWingSeats / allSeats) * 100 }
};

class ParliamentRightWing extends PureComponent {
  render() {
    const { title, text } = this.props;
    const relNumber = parliamentData.rightwing.relSeats + parliamentData.sceptics.relSeats;

    return (
      <Fragment>
        <div className="slide-title">{title}</div>
        <div className="slide-text">{text}</div>
        <div className="parliament__share">
          <div className="slide-share big aside"><strong>{numberFormat(parliamentData.other.relSeats, 1)} %</strong> Sonstige</div>
          <div className="slide-share big main"><strong>{numberFormat(relNumber, 1)} %</strong> EU-Skeptiker</div>
        </div>

        <ParliamentVis data={parliamentData} />

      </Fragment>
    );
  }
}

export default withSlide(ParliamentRightWing);
